import { defineComponent } from 'vue';
import ProgressIndicator from '~/components/common/ProgressIndicator.vue';
export default defineComponent({
  name: 'PlaidSection',
  components: {
    ProgressIndicator
  },
  props: {
    layout: {
      type: Number,
      default: 1
    },
    plaidProcessing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['continue']
});